<template>
  <span class="svg-ico-plus-square">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5981 17.1829C12.2223 17.1829 11.9106 16.8713 11.9106 16.4954V13.5163H8.93164C8.55581 13.5163 8.24414 13.2046 8.24414 12.8288C8.24414 12.4529 8.55581 12.1413 8.93164 12.1413H11.9106V9.16211C11.9106 8.78628 12.2223 8.47461 12.5981 8.47461C12.974 8.47461 13.2856 8.78628 13.2856 9.16211V12.1413H16.265C16.6408 12.1413 16.9525 12.4529 16.9525 12.8288C16.9525 13.2046 16.6408 13.5163 16.265 13.5163H13.2856V16.4954C13.2856 16.8713 12.974 17.1829 12.5981 17.1829Z" :fill="color"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.84831 22.6829H15.3483C20.3258 22.6829 22.4525 20.5563 22.4525 15.5788V10.0788C22.4525 5.10128 20.3258 2.97461 15.3483 2.97461H9.84831C4.87081 2.97461 2.74414 5.10128 2.74414 10.0788V15.5788C2.74414 20.5563 4.87081 22.6829 9.84831 22.6829ZM4.11914 10.0788C4.11914 5.85294 5.62247 4.34961 9.84831 4.34961H15.3483C19.5741 4.34961 21.0775 5.85294 21.0775 10.0788V15.5788C21.0775 19.8046 19.5741 21.3079 15.3483 21.3079H9.84831C5.62247 21.3079 4.11914 19.8046 4.11914 15.5788V10.0788Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
